/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { useSelector, useDispatch } from 'react-redux';
import { AlertBar, MaterialIcon } from '@blend/enterprise-components';
import { State } from '../../../redux';
import { setRoomError } from '../../../actions/roomActions';

export namespace RoomError {
  export interface Props {}
}

const ROOM_HEADER_HEIGHT = 188;
const ALERT_BAR_HEIGHT = 47;

const styles = StyleSheet.create({
  wrapper: {
    position: 'fixed',
    // align alert bar at the bottom of the header
    top: ROOM_HEADER_HEIGHT - ALERT_BAR_HEIGHT / 2,
    maxWidth: 620,
    margin: ' 0 auto',
    left: 0,
    right: 0,
  },
});

export const RoomError: React.FC<RoomError.Props> = ({}) => {
  const dispatch = useDispatch();
  const {
    hasError,
    icon,
    message = 'That action could not be completed. Try again.',
    theme = 'error',
    canCancel = true,
  } = useSelector((reduxState: State) => reduxState.roomDetail.error);

  const cancelProp = canCancel
    ? {
        cancelText: 'Dismiss',
        onCancel: () => setRoomError({ hasError: false })(dispatch),
      }
    : undefined;

  return hasError ? (
    <div className={css(styles.wrapper)}>
      <AlertBar
        data-dd-privacy="allow"
        message={message}
        theme={theme}
        icon={icon as MaterialIcon.Props['type']}
        cancelProps={cancelProp}
      />
    </div>
  ) : null;
};
